// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3bNDX","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2_o2e"};